import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { useCompanyCurrency } from '~hooks/useCompanyCurrency/useCompanyCurrency';

interface RebillSettlementTotalsProps {
  oldTotal: number;
  newTotal: number;
}

export default function RebillSettlementTotals({
  oldTotal,
  newTotal,
}: RebillSettlementTotalsProps) {
  const { currencyFormatter } = useCompanyCurrency();

  const adjustment = newTotal - oldTotal;
  const adjustmentColor = adjustment > 0 ? 'green' : adjustment < 0 ? 'red' : undefined;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, mr: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 400 }}>
            {t('approvals.driver_pay.settlements.pdf.old_total')}:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {currencyFormatter(oldTotal.toFixed(2))}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 400 }}>
            {t('approvals.driver_pay.settlements.pdf.new_total')}:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {currencyFormatter(newTotal.toFixed(2))}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 400 }}>
            {t(
              'approvals.driver_pay.settlements.void_rebill_settlement.adjustments_total',
            )}
            :
          </Typography>
          <Typography variant="body2" sx={{ color: adjustmentColor, fontWeight: 700 }}>
            {currencyFormatter(adjustment.toFixed(2))}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
